<template>
  <!-- FIXME - YOU CAN DO MORE HERE PLEASE TY -->
  <div>Logging you out...</div>
</template>

<script>
export default {
  name: "LogoutView",
  created() {
    this.$store.dispatch("auth/signOut");
  },
};
</script>
